import React from 'react';

const GameCardsWidgetCategoryAsync = React.lazy(() =>
  import('./GameCardsWidgetCategory')
);

export default GameCardsWidgetCategoryAsync;
